import { PlanDetailsBanner } from './plan-details-banner'

export default PlanDetailsBanner
